import HeaderLeft from './src/main';

/* istanbul ignore next */
HeaderLeft.install = function (Vue) {
  Vue.component(HeaderLeft.name, HeaderLeft);
};

export default HeaderLeft;
